import React from "react";

const WFIRSSQuestion3 = ({ questions, renderRadioInputs, questionKey }) => (
  <div key={`WFIRSSQuestion3${questionKey}`}>
    <div className="wfirs-progress-row">
      <div className="wfirs-progress-bar">
        <div style={{ width: "42.9%" }}></div>
      </div>
      <span className="wfirs-counter">3 / 7</span>
    </div>
    <h2 className="wfirs-section-title">Click the number for the rating that best describes how your emotional or behavioral problems have affected your Life Skills.</h2>
    {questions.slice(19, 29).map((question, index) => (
      <div className="wfirs-question" key={index}>
        <label className="wfirs-q-label">{index + 20}. {question.questions}</label>
        {renderRadioInputs(index + 20)}
      </div>
    ))}
  </div>
);

export default WFIRSSQuestion3;
